import script from "./SMSCampaignsModalInactivate.vue?vue&type=script&setup=true&lang=ts"
export * from "./SMSCampaignsModalInactivate.vue?vue&type=script&setup=true&lang=ts"

import "./SMSCampaignsModalInactivate.vue?vue&type=style&index=0&id=7c37e0ee&lang=scss"

const __exports__ = script;

export default __exports__